// src/services/emailService.js
import emailjs from "@emailjs/browser";
import { EMAIL_JS_CONFIG } from '../constants/config';
import { logError } from '../utils/errorHandlers';

/**
 * Send email using EmailJS
 * @param {HTMLFormElement} form - The form element containing the email data
 * @returns {Promise} Promise that resolves when email is sent
 */
export const sendEmail = async (form) => {
    try {
        const result = await emailjs.sendForm(
            EMAIL_JS_CONFIG.serviceId,
            EMAIL_JS_CONFIG.templateId,
            form,
            EMAIL_JS_CONFIG.publicKey
        );
        return result;
    } catch (error) {
        logError('EmailJS Error', error);
        throw error;
    }
};